import React, {useContext} from 'react';
import '../Keyboard.css';
import {ThemeContext} from "../../../../../../../providers/themeContext/theme-context.tsx";

type KeyProps = {
    label?: string;
    onPress: () => void;
}

const HintKey: React.FC<KeyProps> = ({onPress}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);

    const handleKeyPress = () => {
        onPress();
    };

    return (
        <div
            className={`keyboard-hint-btn-container keyboard-hint-btn-container-enable`}
            onClick={handleKeyPress}>
            <img className="keyboard-hint-btn-icon" src={imgUrls.hintKeyboardWhiteIconUrl}
                 alt="hint"/>
        </div>
    );
};

export default HintKey;